// JOBE-0106: TasksTab — full-grid <EntityBrowser> instance pinned to
// `relations.inProject=<urn>` with `urlStateNamespace="tasks"` and a
// default `type=task` chip per spec §Sub-tab body rendering.

import React, { useMemo } from 'react';
import { EntityBrowser } from '../../entitybrowser/EntityBrowser.jsx';
import { FRIENDLY_TOKENS } from '../../library/chipVocabulary.js';

export function TasksTab({ projectURN, roster }) {
  const defaultChips = useMemo(() => ([{
    kind: 'predicate',
    friendlyToken: 'type',
    wirePredicate: FRIENDLY_TOKENS.type?.wirePredicate || 'type',
    values: ['task'],
  }]), []);
  return (
    <div className="project-tab project-tab-tasks" data-testid="project-tab-tasks">
      <EntityBrowser
        anchor={{ inProject: projectURN }}
        urlStateNamespace="tasks"
        roster={roster}
        defaultChips={defaultChips}
      />
    </div>
  );
}
